import { render, staticRenderFns } from "./EditTipo.vue?vue&type=template&id=4387d882"
import script from "./EditTipo.vue?vue&type=script&lang=js"
export * from "./EditTipo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports